<template>
  <!-- ===== 成功态 ===== -->
  <div v-if="innerStatus === 'submitted'" class="chat-card-create-task chat-card-create-task--result">
    <div class="cct-success">
      <div class="cct-success-icon">
        <i class="el-icon-circle-check"></i>
      </div>
      <div class="cct-success-title">任务创建成功</div>
      <div class="cct-success-desc">定时任务已创建，可在自动化中查看，按所选周期自动生成报告</div>

      <div class="cct-success-grid">
        <div class="cct-success-item cct-success-item--full">
          <span class="s-label">任务标题</span>
          <span class="s-value">{{ createdTaskTitle || '-' }}</span>
        </div>
        <div class="cct-success-item">
          <span class="s-label">报告周期</span>
          <span class="s-value">{{ getPeriodLabel() }}</span>
        </div>
        <div class="cct-success-item">
          <span class="s-label">执行时间</span>
          <span class="s-value">{{ getTimeDisplay() }}</span>
        </div>
        <div class="cct-success-item cct-success-item--full">
          <span class="s-label">补充内容</span>
          <span class="s-value">{{ form.supplement || '无' }}</span>
        </div>
      </div>

      <div class="cct-success-actions">
        <el-button
          type="primary"
          class="cct-success-btn"
          size="small"
          @click="handleContinueCreate">
          <i class="el-icon-plus"></i>
          <span>继续创建</span>
        </el-button>
      </div>
    </div>
  </div>

  <!-- ===== 表单态 ===== -->
  <div v-else class="chat-card-create-task">
    <div class="custom-create-task-dialog">
      <!-- Header -->
      <div class="cct-header">
        <span class="cct-title">创建任务</span>
        <div class="cct-header-actions">
          <!-- 模板分类 switch（经营分析 / 市场洞察） -->
          <div class="cct-cat-switch">
            <span
              v-for="opt in categoryOptions"
              :key="opt.value"
              class="cct-cat-option"
              :class="{ active: innerTemplateCategory === opt.value }"
              @click="handleSwitchCategory(opt.value)">
              {{ opt.label }}
            </span>
          </div>
          <!-- <i class="el-icon-plus action-btn" title="重置表单" @click.stop="handleReset"></i> -->
        </div>
      </div>

      <!-- Body -->
      <div class="cct-body">
        <!-- 模板选择 -->
        <div class="cct-form-block">
          <div class="cct-field-desc">选择报告模板或直接描述要...</div>
          <el-select
            v-model="form.templateId"
            placeholder="请选择模板"
            filterable
            class="cct-full"
            @change="handleTemplateChange">
            <el-option
              v-for="item in templateList"
              :key="item.id"
              :label="item.templateName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>

        <!-- 模板所需信息 -->
        <div v-if="templateFields.length > 0" class="cct-form-block template-fields-card">
          <div class="tf-title">
            <i class="el-icon-document-copy"></i>
            模板所需信息（选填，将写入执行指令与报告）
            <span class="tf-count">{{ templateFields.length }} 项</span>
          </div>
          <el-row :gutter="10" class="tf-row">
            <el-col :span="12" v-for="field in templateFields" :key="field.variableKey" class="tf-col">
              <div class="tf-field-label">{{ field.variableLabel }} <span class="tf-optional" v-if="!field.required">(选填)</span></div>
              <el-input
                v-model="form.fields[field.variableKey]"
                :placeholder="field.placeholder || '请输入'"
                size="small">
              </el-input>
            </el-col>
          </el-row>
        </div>

        <!-- 报告周期和执行时间（一直显示） -->
        <div class="cct-form-block cron-block">
          <!-- 报告周期 -->
          <div class="cron-line">
            <span class="cron-label">报告周期</span>
            <div class="form-radio-group">
              <label v-for="p in periodOptions" :key="p.value" class="form-radio-item">
                <input
                  type="radio"
                  v-model="cronPeriod"
                  :value="p.value"
                  @change="onCronPeriodChange">
                <span>{{ p.label }}</span>
              </label>
            </div>
          </div>
          <!-- 执行时间：根据周期显示不同控件 -->
          <div class="cron-line">
            <span class="cron-label">执行时间</span>
            <div class="cron-selects">
              <template v-if="cronPeriod === 'daily'">
                <span class="cron-select-label">每天</span>
                <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                  <el-option v-for="h in 24" :key="h-1" :label="padZero(h-1) + ' 时'" :value="h-1"></el-option>
                </el-select>
                <span class="cron-select-sep">:</span>
                <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                  <el-option v-for="m in cronMinuteOptions" :key="m" :label="padZero(m) + ' 分'" :value="m"></el-option>
                </el-select>
              </template>
              <template v-else-if="cronPeriod === 'weekly'">
                <span class="cron-select-label">每周</span>
                <el-select v-model="cronWeekDay" class="cron-sel" placeholder="周几">
                  <el-option
                    v-for="d in 7"
                    :key="d"
                    :label="weekDayLabel(d)"
                    :value="d"></el-option>
                </el-select>
                <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                  <el-option v-for="h in 24" :key="h-1" :label="padZero(h-1) + ' 时'" :value="h-1"></el-option>
                </el-select>
                <span class="cron-select-sep">:</span>
                <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                  <el-option v-for="m in cronMinuteOptions" :key="m" :label="padZero(m) + ' 分'" :value="m"></el-option>
                </el-select>
              </template>
              <template v-else-if="cronPeriod === 'monthly'">
                <span class="cron-select-label">每月</span>
                <el-select v-model="cronMonthDay" class="cron-sel cron-sel-day" placeholder="日">
                  <el-option v-for="d in 28" :key="d" :label="d + ' 日'" :value="d"></el-option>
                </el-select>
                <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                  <el-option v-for="h in 24" :key="h-1" :label="padZero(h-1) + ' 时'" :value="h-1"></el-option>
                </el-select>
                <span class="cron-select-sep">:</span>
                <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                  <el-option v-for="m in cronMinuteOptions" :key="m" :label="padZero(m) + ' 分'" :value="m"></el-option>
                </el-select>
              </template>
              <template v-else-if="cronPeriod === 'quarterly'">
                <span class="cron-select-label">每季度第</span>
                <el-select v-model="cronQuarterStart" class="cron-sel cron-sel-quarter" placeholder="起始月">
                  <el-option v-for="q in quarterOptions" :key="q.value" :label="q.label" :value="q.value"></el-option>
                </el-select>
                <el-select v-model="cronMonthDay" class="cron-sel cron-sel-day" placeholder="日">
                  <el-option v-for="d in 28" :key="d" :label="d + ' 日'" :value="d"></el-option>
                </el-select>
                <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                  <el-option v-for="h in 24" :key="h-1" :label="padZero(h-1) + ' 时'" :value="h-1"></el-option>
                </el-select>
                <span class="cron-select-sep">:</span>
                <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                  <el-option v-for="m in cronMinuteOptions" :key="m" :label="padZero(m) + ' 分'" :value="m"></el-option>
                </el-select>
              </template>
              <template v-else-if="cronPeriod === 'halfYear'">
                <span class="cron-select-label">每半年</span>
                <el-select v-model="cronMonth" class="cron-sel" placeholder="月">
                  <el-option v-for="mo in [1, 7]" :key="mo" :label="mo + ' 月'" :value="mo"></el-option>
                </el-select>
                <el-select v-model="cronMonthDay" class="cron-sel cron-sel-day" placeholder="日">
                  <el-option v-for="d in 28" :key="d" :label="d + ' 日'" :value="d"></el-option>
                </el-select>
                <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                  <el-option v-for="h in 24" :key="h-1" :label="padZero(h-1) + ' 时'" :value="h-1"></el-option>
                </el-select>
                <span class="cron-select-sep">:</span>
                <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                  <el-option v-for="m in cronMinuteOptions" :key="m" :label="padZero(m) + ' 分'" :value="m"></el-option>
                </el-select>
              </template>
              <template v-else-if="cronPeriod === 'yearly'">
                <span class="cron-select-label">每年</span>
                <el-select v-model="cronMonth" class="cron-sel" placeholder="月">
                  <el-option v-for="mo in 12" :key="mo" :label="mo + ' 月'" :value="mo"></el-option>
                </el-select>
                <el-select v-model="cronMonthDay" class="cron-sel cron-sel-day" placeholder="日">
                  <el-option v-for="d in 28" :key="d" :label="d + ' 日'" :value="d"></el-option>
                </el-select>
                <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                  <el-option v-for="h in 24" :key="h-1" :label="padZero(h-1) + ' 时'" :value="h-1"></el-option>
                </el-select>
                <span class="cron-select-sep">:</span>
                <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                  <el-option v-for="m in cronMinuteOptions" :key="m" :label="padZero(m) + ' 分'" :value="m"></el-option>
                </el-select>
              </template>
            </div>
          </div>
          <div class="cron-preview">
            <span class="cron-preview-label">Cron 表达式：</span>
            <code class="cron-preview-value">{{ computedCronExpression }}</code>
          </div>
        </div>

        <!-- 是否立即执行 -->
        <div class="cct-form-block">
          <div class="cct-field-desc" style="margin-bottom: 6px;">是否立即执行</div>
          <div class="form-radio-group">
            <label class="form-radio-item">
              <input type="radio" v-model="form.runImmediately" :value="true">
              <span>是</span>
            </label>
            <label class="form-radio-item">
              <input type="radio" v-model="form.runImmediately" :value="false">
              <span>否</span>
            </label>
          </div>
        </div>

        <!-- 补充内容 -->
        <div class="cct-form-block">
          <el-input
            type="textarea"
            v-model="form.supplement"
            placeholder="输入补充内容"
            :rows="5"
            resize="none">
          </el-input>
        </div>

        <!-- 推送渠道 -->
        <div class="cct-form-block">
          <div class="cct-field-desc" style="margin-bottom: 6px;">推送渠道</div>
          <push-channel-select
            v-model="pushChannels"
            :agent-id="effectiveAgentId"
            source="chat-card-create-task"
          />
        </div>
      </div>

      <!-- Submit Float Button (右下角蓝色圆形发送) -->
      <!-- <el-button
        type="primary"
        class="cct-submit-btn"
        circle
        :loading="submitting"
        size="medium"
        icon="el-icon-upload2"
        @click.stop="handleSubmit">
      </el-button> -->
      <el-button
        type="primary"
        class="cct-submit-btn"
        circle
        :loading="submitting"
        size="medium"
        @click.stop="handleSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { createJobApi, runJobApi } from '@/api/agentAuth'
import { getTemplateList, getTemplateDetail, createReportTitle } from '@/api/agents/agent'
import PushChannelSelect from '@/components/PushChannelSelect.vue'

export default {
  name: 'ChatCardCreateTask',
  components: { PushChannelSelect },
  props: {
    category: { type: String, default: 'internal' },
    agentId: { type: String, default: '' },
    currentAgentId: { type: String, default: '' },
    templateCategory: {
      type: String,
      default: '经营分析' // 默认经营分析
    },
    initialState: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    computedCronExpression() {
      const m = this.cronMinute
      const h = this.cronHour
      const d = this.cronMonthDay
      switch (this.cronPeriod) {
        case 'daily':
          return `${m} ${h} * * ?`
        case 'weekly':
          return `${m} ${h} ? * ${this.cronWeekDay}`
        case 'monthly':
          return `${m} ${h} ${d} * ?`
        case 'quarterly': {
          const m1 = this.cronQuarterStart
          return `${m} ${h} ${d} ${m1},${m1 + 3},${m1 + 6},${m1 + 9} ?`
        }
        case 'halfYear':
          return `${m} ${h} ${d} 1,7 ?`
        case 'yearly':
          return `${m} ${h} ${d} ${this.cronMonth} ?`
        default:
          return `${m} ${h} * * ?`
      }
    },
    /** 当前正在配置任务的数字人 ID：route.query.agentId > props.agentId > props.currentAgentId > store */
    effectiveAgentId() {
      return (
        (this.$route && this.$route.query && this.$route.query.agentId) ||
        this.agentId ||
        this.currentAgentId ||
        (this.$store && this.$store.state && this.$store.state.cosmoClaw && this.$store.state.cosmoClaw.currentAgentId) ||
        ''
      )
    }
  },
  data() {
    return {
      innerStatus: 'form', // form | submitted
      createdTaskTitle: '',
      innerTemplateCategory: this.templateCategory || '经营分析',
      categoryOptions: [
        { label: '经营分析', value: '经营分析' },
        { label: '市场洞察', value: '市场洞察' }
      ],
      templateList: [],
      templateFields: [],
      submitting: false,
      periodOptions: [
        { label: '日', value: 'daily' },
        { label: '周', value: 'weekly' },
        { label: '月', value: 'monthly' },
        { label: '季度', value: 'quarterly' },
        { label: '半年', value: 'halfYear' },
        { label: '年', value: 'yearly' }
      ],
      cronPeriod: 'daily',
      cronHour: 9,
      cronMinute: 0,
      cronMonthDay: 1,
      cronMonth: 1,
      cronQuarterStart: 1,
      /** 周报周几选择（1-7，1=周一 ... 7=周日） */
      cronWeekDay: 1,
      /** 已选推送渠道 code 列表 */
      pushChannels: [],
      quarterOptions: [
        { value: 1, label: 'Q1(1月)' },
        { value: 4, label: 'Q2(4月)' },
        { value: 7, label: 'Q3(7月)' },
        { value: 10, label: 'Q4(10月)' }
      ],
      cronMinuteOptions: Array.from({ length: 12 }, (_, i) => i * 5),
      form: this.getInitialForm()
    }
  },
  watch: {
    templateCategory(val) {
      if (val && val !== this.innerTemplateCategory) {
        this.innerTemplateCategory = val
        this.loadTemplateList()
      }
    },
    // 切换数字人（effectiveAgentId 变化）时，清空已选渠道
    effectiveAgentId: {
      handler(newVal, oldVal) {
        if (!newVal || newVal === oldVal) return
        this.pushChannels = []
      }
    }
  },
  created() {
    this.loadTemplateList()
    this.applyInitialState(this.resolveState(this.initialState))
  },
  methods: {
    // JSON 字符串兜底解析（md-renderer 会把对象 props JSON.stringify）
    safeParse(val, fallback) {
      if (val === null || val === undefined) return fallback
      if (typeof val === 'object') return val
      if (typeof val !== 'string') return fallback
      if (!(val.startsWith('{') || val.startsWith('['))) return fallback
      try { return JSON.parse(val) } catch (e) { return fallback }
    },
    resolveState(state) {
      if (!state) return {}
      const resolved = this.safeParse(state, {}) || {}
      if (resolved && resolved.fields) resolved.fields = this.safeParse(resolved.fields, {}) || {}
      return resolved
    },
    getInitialForm() {
      return {
        templateId: '',
        fields: {},
        supplement: '',
        runImmediately: false
      }
    },
    padZero(n) {
      return n < 10 ? '0' + n : '' + n
    },
    /**
     * 周几下拉展示文案：周一..周日
     */
    weekDayLabel(d) {
      const names = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
      const idx = Math.max(0, Math.min(6, (d || 1) - 1))
      return names[idx]
    },
    onCronPeriodChange() {
      this.cronMinute = 0
      this.cronHour = 9
      this.cronMonthDay = 1
      this.cronMonth = 1
      this.cronQuarterStart = 1
      this.cronWeekDay = 1
    },
    handleReset() {
      this.form = this.getInitialForm()
      this.templateFields = []
      this.cronPeriod = 'daily'
      this.cronHour = 9
      this.cronMinute = 0
      this.cronMonthDay = 1
      this.cronMonth = 1
      this.cronQuarterStart = 1
      this.cronWeekDay = 1
      this.pushChannels = []
      this.innerStatus = 'form'
      this.createdTaskTitle = ''
    },
    handleContinueCreate() {
      this.handleReset()
      this.$emit('continue-create')
    },
    // ===== 模板分类 switch 切换 =====
    handleSwitchCategory(val) {
      if (val === this.innerTemplateCategory) return
      this.innerTemplateCategory = val
      this.$emit('update:templateCategory', val)
      // 切换后重新拉模板并重置表单
      this.form = this.getInitialForm()
      this.templateFields = []
      this.loadTemplateList()
    },

    // ===== initialState 回显 =====
    applyInitialState(state) {
      if (!state || typeof state !== 'object' || Object.keys(state).length === 0) return
      const s = state
      if (typeof s.templateCategory === 'string' && s.templateCategory) {
        this.innerTemplateCategory = s.templateCategory
        // 重新拉对应模板列表
        this.loadTemplateList()
      }
      if (typeof s.templateId === 'string') {
        this.form.templateId = s.templateId
      }
      if (s.fields && typeof s.fields === 'object') {
        this.form.fields = { ...s.fields }
      }
      if (typeof s.supplement === 'string') {
        this.form.supplement = s.supplement
      }
      if (typeof s.runImmediately === 'boolean') {
        this.form.runImmediately = s.runImmediately
      }
      if (typeof s.cronPeriod === 'string') {
        this.cronPeriod = s.cronPeriod
      }
      if (typeof s.cronHour === 'number') {
        this.cronHour = s.cronHour
      }
      if (typeof s.cronMinute === 'number') {
        this.cronMinute = s.cronMinute
      }
      if (typeof s.cronMonthDay === 'number') {
        this.cronMonthDay = s.cronMonthDay
      }
      if (typeof s.cronMonth === 'number') {
        this.cronMonth = s.cronMonth
      }
      if (typeof s.cronQuarterStart === 'number') {
        this.cronQuarterStart = s.cronQuarterStart
      }
      // 如果设置了 templateId 且模板列表已加载，触发字段加载
      if (this.form.templateId && this.templateList.length > 0) {
        this.handleTemplateChange(this.form.templateId, /* preserveFields*/ true)
      }
    },

    // ===== 数据加载 =====
    async loadTemplateList() {
      try {
        const params = {}
        if (this.innerTemplateCategory) {
          params.templateCategory = this.innerTemplateCategory
        }
        const res = await getTemplateList(params)
        if (res && res.code === 200) {
          const list = Array.isArray(res.data) ? res.data : []
          this.templateList = list.filter(t => t.templateStatus === 1)
          // 回显：如果 initialState 有 templateId，此时触发字段加载并保留 fields 值
          if (this.form.templateId) {
            this.handleTemplateChange(this.form.templateId, /* preserveFields*/ true)
          }
          if (this.templateList.length === 0) {
            this.$message.info('暂无可用模板')
          }
        } else {
          this.$message.error(res?.message || '加载模板列表失败')
        }
      } catch (e) {
        console.error('加载模板列表失败:', e)
        this.$message.error('加载模板列表失败')
      }
    },
    async handleTemplateChange(templateId, preserveFields = false) {
      if (!templateId) {
        this.templateFields = []
        this.form.fields = {}
        return
      }
      try {
        const res = await getTemplateDetail(templateId)
        if (res && res.code === 200 && res.data) {
          const variables = Array.isArray(res.data.variables) ? res.data.variables : []
          this.templateFields = variables
            .filter(v => v.variableType === 'input')
            .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
          const oldFields = preserveFields ? this.form.fields : {}
          const newFields = {}
          this.templateFields.forEach(f => {
            newFields[f.variableKey] =
              typeof oldFields[f.variableKey] !== 'undefined' ? oldFields[f.variableKey] : ''
          })
          this.form.fields = newFields
        } else {
          this.$message.error(res?.message || '加载模板字段失败')
          this.templateFields = []
          this.form.fields = {}
        }
      } catch (e) {
        console.error('加载模板字段失败:', e)
        this.$message.error('加载模板字段失败')
        this.templateFields = []
        this.form.fields = {}
      }
    },
    // ===== 提交 =====
    async handleSubmit() {
      if (!this.form.templateId) {
        this.$message.warning('请选择模板')
        return
      }
      this.submitting = true
      try {
        // Step 1: 生成任务标题和内容
        const genRes = await createReportTitle({
          id: this.form.templateId,
          variableValues: this.form.fields,
          supplement: this.form.supplement
        })
        if (!genRes || genRes.code !== 200 || !genRes.data) {
          this.$message.error(genRes?.message || '生成任务内容失败')
          return
        }
        const { title, content } = genRes.data
        if (!title || !content) {
          this.$message.error('生成的任务标题或内容为空')
          return
        }

        // Step 2: 创建任务
        const finalAgentId = this.effectiveAgentId
        const reportConfig = {
          reportType: 'market',
          category: this.category,
          decision: false
        }
        // 推送渠道：去重 + 去空，约定嵌入 reportConfig.pushChannels
        const channels = Array.from(new Set((this.pushChannels || []).filter(Boolean)))
        if (channels.length) {
          reportConfig.pushChannels = channels
        }
        const createParams = {
          name: title,
          agentId: finalAgentId,
          taskType: 'report',
          cronExpression: this.computedCronExpression,
          enabled: true,
          triggerMessage: content,
          source: 'manual',
          reportConfig: JSON.stringify(reportConfig)
        }

        const createRes = await createJobApi(createParams)
        const isSuccess = !createRes || createRes.code === 200 || createRes.code === '200' || createRes.code === 0
        if (!isSuccess) {
          this.$message.error(createRes?.message || '创建任务失败')
          return
        }

        this.$message.success('任务创建成功')
        const newTaskId = createRes?.data?.id || createRes?.id || null
        this.createdTaskTitle = title

        // Step 3: 如果勾选了立即执行
        if (this.form.runImmediately && newTaskId) {
          try {
            const runRes = await runJobApi(newTaskId)
            const runOk = !runRes || runRes.code === 200 || runRes.code === '200' || runRes.code === 0
            if (runOk) {
              this.$message.success('已触发立即执行')
            } else {
              this.$message.warning('任务已创建，但触发执行失败：' + (runRes?.message || ''))
            }
          } catch (re) {
            console.error('立即执行失败:', re)
            this.$message.warning('任务已创建，但触发执行失败')
          }
        }

        this.$emit('task-created', {
          runImmediately: !!this.form.runImmediately,
          taskId: newTaskId,
          title
        })

        // 切到成功态
        this.innerStatus = 'submitted'
      } catch (e) {
        console.error('提交任务失败:', e)
        this.$message.error(e?.message || '提交任务失败')
      } finally {
        this.submitting = false
      }
    },
    // ===== 成功态辅助 =====
    getPeriodLabel() {
      const map = {
        daily: '每日',
        weekly: '每周',
        monthly: '每月',
        quarterly: '每季度',
        halfYear: '每半年',
        yearly: '每年'
      }
      return map[this.cronPeriod] || this.cronPeriod
    },
    getTimeDisplay() {
      const h = this.padZero(this.cronHour)
      const m = this.padZero(this.cronMinute)
      const time = `${h}:${m}`
      switch (this.cronPeriod) {
        case 'daily':
          return `每天 ${time}`
        case 'weekly':
          return `每周${this.weekDayLabel(this.cronWeekDay)} ${time}`
        case 'monthly':
          return `每月 ${this.cronMonthDay} 日 ${time}`
        case 'quarterly': {
          const qMap = { 1: 'Q1', 4: 'Q2', 7: 'Q3', 10: 'Q4' }
          return `每${qMap[this.cronQuarterStart] || '季度'} 第 ${this.cronMonthDay} 日 ${time}`
        }
        case 'halfYear':
          return `每${this.cronMonth === 1 ? '上半年' : '下半年'} ${this.cronMonthDay} 日 ${time}`
        case 'yearly':
          return `每年 ${this.cronMonth} 月 ${this.cronMonthDay} 日 ${time}`
        default:
          return time
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-card-create-task {
  width: 100%;
}

.custom-create-task-dialog {
  width: 100%;
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: visible;
  padding-bottom: 48px;
  position: relative;
  animation: cct-appear 0.18s ease-out;
}

@keyframes cct-appear {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ===== Header ===== */
.cct-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px 8px;
}
.cct-title {
  font-size: 15px;
  font-weight: 500;
  color: #1F2329;
}
.cct-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.action-btn {
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 16px;
  color: #606266;
  cursor: pointer;
  border-radius: 4px;
  transition: all .18s;
  display: inline-block;
  &:hover {
    background: #F2F3F5;
    color: #1F2329;
  }
}

/* ===== 模板分类 switch ===== */
.cct-cat-switch {
  display: inline-flex;
  background: #F2F3F5;
  border-radius: 6px;
  padding: 2px;
  gap: 2px;
}
.cct-cat-option {
  padding: 4px 12px;
  font-size: 12px;
  color: #606266;
  border-radius: 5px;
  cursor: pointer;
  transition: all .18s;
  user-select: none;
  &.active {
    background: #FFFFFF;
    color: #4A5FF3;
    font-weight: 500;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }
  &:not(.active):hover {
    color: #303133;
  }
}

/* ===== Body ===== */
.cct-body {
  padding: 4px 18px 0;
}

.cct-form-block {
  margin-bottom: 16px;
}

.cct-field-desc {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.cct-full {
  width: 100%;
}

/* 模板字段卡片 */
.template-fields-card {
  background: #F7F8FC;
  border-radius: 8px;
  padding: 12px 14px 6px;
  .tf-title {
    font-size: 12px;
    color: #4A5FF3;
    font-weight: 500;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 4px;
    .tf-count {
      margin-left: auto;
      color: #606266;
      font-weight: 400;
    }
  }
  .tf-col {
    margin-bottom: 6px;
  }
  .tf-field-label {
    font-size: 12px;
    color: #606266;
    margin-bottom: 4px;
    .tf-optional {
      color: #C0C4CC;
    }
  }
}

/* 定时设置 Cron */
.cron-block {
  background: #FAFBFC;
  border-radius: 8px;
  padding: 12px 14px;
  border: 1px solid #EBEEF5;
  .cron-line {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    &:last-of-type { margin-bottom: 8px; }
  }
  .cron-label {
    font-size: 12px;
    color: #606266;
    width: 64px;
    flex-shrink: 0;
  }
  .cron-preview {
    font-size: 11px;
    color: #909399;
    .cron-preview-label {
      color: #909399;
    }
    .cron-preview-value {
      background: #FFFFFF;
      border: 1px solid #EBEEF5;
      padding: 1px 6px;
      border-radius: 3px;
      font-family: Consolas, monospace;
      color: #4A5FF3;
    }
  }
}

.cron-selects {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
  color: #606266;
  > span { line-height: 28px; }
}
.cron-select-label {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}
.cron-select-sep {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 600;
}
.cron-sel {
  width: 110px;
}
.cron-sel-day {
  width: 100px;
}
.cron-sel-quarter {
  width: 130px;
}

.form-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  .form-radio-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-size: 13px;
    color: #606266;
  }
}

/* ===== 右下角发送按钮 ===== */
.cct-submit-btn {
  position: absolute;
  right: 18px;
  bottom: 10px;
  width: 80px;
  border-radius: 8px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(74, 95, 243, 0.45);
  background: #4A5FF3;
  border-color: #4A5FF3;
  z-index: 10;
  transition: transform .15s;
  &:hover {
    transform: translateY(-2px);
    background: #3d50e0;
    border-color: #3d50e0;
  }
  &::after {
    display: none;
  }
}

/* ===== 成功态 ===== */
.chat-card-create-task--result {
  width: 560px;
  max-width: 100%;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(74, 95, 243, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.cct-success {
  padding: 40px 32px 32px;
  text-align: center;
  background: #fff;
  border-radius: 10px;
}
.cct-success-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ecfef0 0%, #d9fae2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(82, 196, 26, 0.15);
  i {
    font-size: 40px;
    color: #52c41a;
  }
}
.cct-success-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}
.cct-success-desc {
  font-size: 13px;
  color: #8b95a7;
  line-height: 1.7;
  margin-bottom: 28px;
  max-width: 460px;
  margin-left: auto;
  margin-right: auto;
}
.cct-success-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 40px;
  text-align: left;
  padding: 24px 28px;
  background: linear-gradient(180deg, #fafbff 0%, #f5f7ff 100%);
  border: 1px solid #eef0fa;
  border-radius: 10px;
  margin-bottom: 28px;
}
.cct-success-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  align-items: flex-start;
  justify-content: center;
  padding: 8px 4px;
  min-width: 0;
  &--full {
    grid-column: 1 / -1;
  }
  .s-label {
    font-size: 11px;
    color: #94a0b4;
    letter-spacing: 0.3px;
  }
  .s-value {
    font-size: 14px;
    color: #1f2937;
    font-weight: 600;
    line-height: 1.5;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.cct-success-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}
.cct-success-btn {
  font-size: 13px;
  padding: 10px 24px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #4A5FF3 0%, #6b7ef5 100%);
  border-color: #4A5FF3;
  color: #fff;
  box-shadow: 0 4px 12px rgba(74, 95, 243, 0.25);
  transition: all 0.2s ease;
  &:hover {
    background: linear-gradient(135deg, #3d50e0 0%, #5b6ef0 100%);
    border-color: #3d50e0;
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(74, 95, 243, 0.32);
  }
}
</style>
